import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';

import Link from '../../../Core/Link';
import MultiColumnLayout from '../MultiColumnLayout';

import { FullWidthImage, Wrapper, StyledContainer, Card } from './styles';

function BlogBannerCards({ sectionId, data }) {
  if (!data) return null;
  const {
    titleHtml,
    image,
    imageSharp,
    columnCount,
    items,
    colourOverrideBackground,
    colourOverrideCardBG,
    lang,
  } = data;

  return (
    <Wrapper id={sectionId} colourOverrideBackground={colourOverrideBackground}>
      <FullWidthImage src={imageSharp} alt={image.altTag} objectFit="cover" />
      <StyledContainer className="auto-margin">
        {ReactHtmlParser(titleHtml)}
        <MultiColumnLayout columns={columnCount} spacing="10px">
          {items.map(
            ({ textBoxHtml, cta, ctaText, ariaLabel, queryString }, index) => (
              <Card
                key={`blog-cards-${cta.url}-${index.toString()}`}
                colourOverrideCardBG={colourOverrideCardBG}
              >
                {ReactHtmlParser(textBoxHtml)}
                <Link
                  to={`${cta.url}/`}
                  ariaLabel={ariaLabel}
                  queryString={queryString}
                  lang={lang}
                >
                  {ctaText}
                </Link>
              </Card>
            )
          )}
        </MultiColumnLayout>
      </StyledContainer>
    </Wrapper>
  );
}

BlogBannerCards.propTypes = {
  data: PropTypes.shape().isRequired,
  sectionId: PropTypes.string.isRequired,
};

export default BlogBannerCards;
